import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="relative max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20Japanese%20ninja%20themed%20summer%20scene%20with%20creative%20watermelon%20art%20displays%2C%20warm%20evening%20light%2C%20wooden%20table%20with%20carved%20watermelons%2C%20festival%20atmosphere%2C%20dark%20background%20with%20lanterns%2C%20professional%20food%20photography%20style&width=1600&height=600&seq=cta-section-01&orientation=landscape"
            alt="加入火影西瓜社区"
            title="火影西瓜创意社区"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
          <div className="relative z-10 py-16 md:py-20 px-6 md:px-10 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
              准备好开启你的忍者吃瓜之旅了吗？
            </h2>
            <p className="text-white/70 text-sm md:text-base max-w-lg mx-auto mb-8">
              加入火影西瓜爱好者社区，分享你的创意作品，学习更多忍者西瓜玩法
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/zaoxing-diy"
                className="px-6 py-3 bg-accent-500 text-white rounded-full text-sm font-medium hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                立即探索
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}